<template>
  <v-app id="login" class="">
    <v-container fluid fill-height pa-0>
      <!--<v-layout align-center justify-center>-->
      <v-layout row wrap>
        <v-flex sm6 md8 lg8>
          <div id="divider"></div>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4
          lg4
          style="display: flex; align-items: center; flex-direction: column"
        >
          <v-form :model="this.model" class="registerForm">
            <h3 class="text-h3 mt-5 mb-3">Registrar</h3>
            <v-btn rounded outlined @click.prevent="auth('facebook')">
              <v-icon class="mr-2" color="blue"
                >fa fa-facebook-square fa-lg</v-icon
              >
              Inscreva-se com Facebook
            </v-btn>

            <v-btn rounded outlined @click.prevent="auth('google')">
              <v-icon class="mr-2" color="red">fa fa-google fa-lg</v-icon>
              Inscreva-se com Google
            </v-btn>
            <v-text-field
              label="Nome Completo"
              name="nome"
              placeholder=""
              v-model="model.name"
              v-validate="'required'"
              data-vv-name="nome"
              :error-messages="errors.collect('nome')"
              required
              outlined
              dense
              hide-details="auto"
              append-icon="account_circle"
            ></v-text-field>
            <v-text-field
              label="Email"
              placeholder="seu melhor email (precisa ser válido)"
              name="email"
              outlined
              dense
              hide-details="auto"
              v-validate="'required|email'"
              data-vv-name="email"
              :error-messages="errors.collect('email')"
              v-model="model.email"
              required
              append-icon="alternate_email"
            ></v-text-field>
            <!--<v-text-field-->
            <!--label="CPF"-->
            <!--placeholder="CPF com 11 digitos"-->
            <!--name="cpf"-->
            <!--v-validate="'required|min:11|max:11'"-->
            <!--data-vv-name="cpf"-->
            <!--:error-messages="errors.collect('cpf')"-->
            <!--v-model="model.cpf"-->
            <!--maxlength="11"-->
            <!--mask="###########"-->
            <!--append-icon="contacts"-->
            <!--required>-->
            <!--</v-text-field>-->
            <!--<v-text-field-->
            <!--label="Telefone"-->
            <!--placeholder="(##) #####-####"-->
            <!--v-validate="'required|min:10'"-->
            <!--data-vv-name="telefone"-->
            <!--:error-messages="errors.collect('telefone')"-->
            <!--v-model="model.phone"-->
            <!--mask="(##) #####-####"-->
            <!--required-->
            <!--append-icon="phone"-->
            <!--&gt;-->
            <!--</v-text-field>-->
            <v-text-field
              append-icon="lock"
              name="password"
              label="Senha"
              type="password"
              v-model="model.password"
              data-vv-name="senha"
              v-validate="'required|min:6'"
              v-on:keyup.13="submit"
              :v-errors="errors"
              :error-messages="errors.collect('senha')"
              required
              outlined
              dense
              hide-details="auto"
            >
            </v-text-field>
            <v-text-field
              append-icon="lock"
              name="password_confirmation"
              label="Confirmação"
              id="password_confirmation"
              type="password"
              v-model="model.password_confirmation"
              data-vv-name="senha"
              v-validate="'required'"
              v-on:keyup.13="submit"
              :v-errors="errors"
              required
              outlined
              dense
              hide-details="auto"
            >
            </v-text-field>
            <v-btn
              color="primary"
              style="margin: 0 -2px"
              rounded
              @click="submit"
              :loading="logging"
              >Cadastrar</v-btn
            >
            <v-btn v-on:keyup.13="submit" small text :to="{ name: 'login' }"
              >Já tenho conta</v-btn
            >
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import UsersServices from "../../services/users.service";
import { socialLogin } from "@/services/auth.service";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    logging: false,
    model: {
      email: "",
      password: "",
    },
  }),
  mounted() {
    // console.log(this.$refs.form)
  },
  computed: mapGetters({
    user: "authUser",
    authenticated: "authCheck",
  }),
  methods: {
    async submit() {
      if (await this.formHasErrors()) return;
      this.logging = true;

      try {
        const response = await UsersServices.registerUser(this.model);

        this.logging = false;

        window.getApp.sendSnackMessage("Usuário registrado com sucesso 😎");
        this.$gtag.query("event", "sign_up", {
          method: "email",
        });

        await this.createSession(response.data);

        if (this.$route.query.redirect === "/login") {
          this.$router.push({ name: "courses" });
        } else if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push({ name: "courses" });
        }

        this.$emit("logged", this.user);
      } catch (ex) {
        this.logging = false;
        window.getApp.sendSnackMessage(ex.message, "error");
      }
    },

    async createSession(authData) {
      // console.log('creating session')
      await this.$store.dispatch("saveToken", {
        token: authData.token,
      });
      // Fetch the user.
      this.$store.dispatch("fetchUser");
    },
    redirect() {
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);
      } else this.$router.push({ name: "login" });
    },
    auth: function (network) {
      const _this = this;
      const hello = this.hello;
      hello(network)
        .login({
          scope: "email",
          force: false,
          auth_type: "rerequest",
        })
        .then(() => {
          const authRes = hello(network).getAuthResponse();
          /*
            performs operations using the token from authRes
          */
          this.logging = true;
          hello(network)
            .api("me")
            .then(function (profile) {
              /*
                performs operations using the user info from profile
              */
              // console.log(authRes)
              // console.log('social login')
              socialLogin(authRes, profile, "google").then(async (r) => {
                // console.log(r)
                await _this.createSession(r.data);
                if (_this.redirect) _this.$router.push({ name: "home" });
                // _this.logging = false
                _this.$emit("logged", _this.user);
                _this.$gtag.query("event", "sign_up", {
                  method: network,
                });
              });
              // console.log(_this.redirect)
            });
        });
      this.logging = false;
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 0%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

#divider {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
  background-image: url("/img/login/tubarao-10.jpg");
  background-size: cover;
  overflow: hidden;
}

.registerForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;
  width: 100%;
  max-width: 330px;
  padding: 16px;
}
</style>
